export function createPlaybackPositionTracker(ctx) {
    let playing = false;
    let startTime = 0;
    let trackingSampleRate = 0;
    return {
        start(sampleRate) {
            startTime = ctx.currentTime;
            trackingSampleRate = sampleRate;
            playing = true;
        },
        stop() {
            playing = false;
        },
        getCurrentSample() {
            if (!playing)
                return -1;
            return Math.floor((ctx.currentTime - startTime) * trackingSampleRate);
        },
        get isPlaying() {
            return playing;
        },
        dispose() {
            playing = false;
        },
    };
}
//# sourceMappingURL=playback-position-tracker.js.map